import throttle from "../utils/throttle";
import isFullyInViewPort from "../utils/isFullyInViewport";

document.addEventListener("DOMContentLoaded", () => {
  const aboutUsLink = document.querySelector(".about-us-link-container");

  if (aboutUsLink) {
    function toggleVisibility() {
      if (isFullyInViewPort(aboutUsLink)) {
        aboutUsLink.classList.remove("link-hidden");
        aboutUsLink.classList.add("link-visible");
      } else {
        aboutUsLink.classList.remove("link-visible");
        aboutUsLink.classList.add("link-hidden");
      }
    }

    aboutUsLink.classList.add("link-hidden");
    const throttledFunction = throttle(toggleVisibility, 100);

    window.addEventListener("scroll", throttledFunction);
    toggleVisibility(); // Initial Check
  }
});
